import { useSelector } from 'react-redux';
import selectors from '../../redux/selectors/selectors';
import { Icon, PageWithLoading } from '../../shared/components';
import FloatingContactForm from '../../shared/components/FloatingContactForm';
import { StatusPagesTable } from '../../features/status/status-pages-table';
import { useState } from 'react';
import { Button, notification } from 'antd';
import { post } from '../../redux/lib/api';
import { getStatusPages } from '../../redux/actions/statusPageActions';
import useBoundForm from '../../shared/hooks/useBoundForm';
import BasicSlideOut from '../../shared/components/BasicSlideOut';
import BoundFormGroup from '../../shared/components/boundForm/BoundFormGroup';
import { UpgradeModal } from '../../features/upgrade/upgrade-modal';

export function StatusPage() {
  const isInitializing = useSelector(selectors.isInitializing);
  const isFreeTier = useSelector(selectors.isFreeTier);
  const addForm = useBoundForm({});

  const [showFreeTierUpgrade, setShowFreeTierUpgrade] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);

  const addStatusPage = () => {
    post('status_page', {
      data: addForm.state,
    }).then((response) => {
      if (response) {
        notification.success({
          message: 'Success',
          description: 'Status page added',
        });
      }
      getStatusPages().then(() => {
        setShowAddModal(false);
      });
    });
  };

  const addFields = [[{ id: 'friendly_name', label: 'Name', placeholder: 'Name', required: true }]];

  return (
    <PageWithLoading
      isLoading={isInitializing}
      actions={
        <Button
          onClick={() => {
            if (isFreeTier) {
              setShowFreeTierUpgrade(true);
              return;
            }
            addForm.setState({});
            setShowAddModal(true);
          }}
          className="primary_big"
          icon={
            <Icon
              name="plus"
              size={12}
            />
          }>
          Add Status Page
        </Button>
      }>
      <StatusPagesTable />

      <UpgradeModal
        show={showFreeTierUpgrade}
        onHide={() => setShowFreeTierUpgrade(false)}
      />
      <BasicSlideOut
        showSlideOut={showAddModal}
        hideSlideOut={() => setShowAddModal(false)}
        title="Add Status Page"
        body={
          <BoundFormGroup
            formId={addForm.id}
            fields={addFields}
          />
        }
        submitText={'Add'}
        onSubmit={addStatusPage}
      />

      <FloatingContactForm />
    </PageWithLoading>
  );
}
